import Vue from 'vue'
import i18n from '@ms/lang/i18n.js'
import DialogLogin from './DialogLogin.vue'
import { isApp } from 'wap/hybrid/device'
import { gotoAppLogin } from 'wap/hybrid'

const DialogLoginConstructor = Vue.extend(DialogLogin)

let insLogin = null

export const openLogin = ({ showClose = true, noChangeRegion = false, checkKyc = false, onSuccess = null, onClose = null } = {}) => {
  // 针对静态打包的 app WebView 使用原生登录
  if (process.env.PLATFORM === 'local' && isApp()) {
    return gotoAppLogin()
  }

  if (!insLogin) {
    insLogin = new DialogLoginConstructor({ i18n })
    insLogin.update({
      showClose,
      noChangeRegion,
      checkKyc,
      onSuccess,
      onClose
    })
    insLogin.$mount()
    document.querySelector('body').appendChild(insLogin.$el)
    insLogin.open()
  } else {
    insLogin.update({
      showClose,
      noChangeRegion,
      checkKyc,
      onSuccess,
      onClose
    })
    insLogin.open()
  }
}

Vue.prototype.$login = openLogin
